import { render } from "./reallocator-block.vue?vue&type=template&id=60f4ed5f&scoped=true"
import script from "./reallocator-block.vue?vue&type=script&lang=js"
export * from "./reallocator-block.vue?vue&type=script&lang=js"

import "./reallocator-block.vue?vue&type=style&index=0&id=60f4ed5f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f4ed5f"]])

export default __exports__